import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import {Route, RouterModule } from '@angular/router';

import { HomeownerAppComponent } from './app.component';
import { LayoutModule } from '@angular/cdk/layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenuComponent } from './components/menu/menu/menu.component';
import { SharedModule } from './modules/_shared/shared.module';
import { CommonModule } from '@angular/common';
import { QualificationModule,  DialogSolutionDeployingComponent, HelpApiService, HelpGqlService, AppLoadService, EbbIntegrationModule } from '@ebb-v2/ebb-integration';
import { environment } from './../environments/environment';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ProgramClosedComponent } from './modules/_shared/components/program-closed/program-closed.component';
import { RegistrationCompletedComponent } from './modules/_shared/components/registrationcompleted/registrationcompleted.component';
import { NavigationService } from './modules/_shared/services/navigationservice/navigation.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AuthGuard } from './app-routing-auth-guard';
import { DeviceDetectorService } from 'ngx-device-detector';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
export function appInit(appLoadService: AppLoadService) {
  return () => appLoadService.loadSettings();
}
export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'register',
    pathMatch: 'full'
  },
  {
    path: 'complete',
    component: RegistrationCompletedComponent, canActivate: [AuthGuard] 
  },
  {
    path: 'status/:type',
    component: ProgramClosedComponent,
    
  },
  {
    path: 'register',
    loadChildren: () => import('./modules/registration/registration.module').then(m => m.RegistrationModule),
    canActivate: [AuthGuard]
  }
];
@NgModule({
  declarations: [
    HomeownerAppComponent,
    MenuComponent,
    DialogSolutionDeployingComponent
  ],
  imports: [
    EbbIntegrationModule,
    CommonModule,
    SharedModule,
    QualificationModule,
    BrowserModule,
    BrowserAnimationsModule,
    LayoutModule,
    MatCardModule,    NgxMaskDirective,NgxMaskPipe,
    RecaptchaModule,
    RecaptchaFormsModule, ModalModule.forRoot(),
    RouterModule.forRoot(appRoutes, {
      enableTracing: !environment.production,
      scrollPositionRestoration: 'enabled'
    }),
  ],
  providers: [
    AppLoadService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      deps: [AppLoadService],
      multi: true
    },
    provideNgxMask(),NavigationService, DeviceDetectorService,
    { provide: HelpApiService, useClass: HelpGqlService },
    {
           provide: RECAPTCHA_SETTINGS,
           useFactory: (appLoadService: AppLoadService): RecaptchaSettings => ({
             siteKey: appLoadService.getRecaptchaKey()
           }),
           deps: [AppLoadService]
         },
  ],
  // entryComponents: [
  //   DialogSolutionDeployingComponent
  // ],
  bootstrap: [ HomeownerAppComponent ]
})
export class HomeownerAppModule {}
